module.exports = __webpack_public_path__ + "img/do_not_distrub.3d172aae.svg";